import React, { useState, useEffect } from 'react';
import Typography from '@mui/material/Typography';
import GppMaybeIcon from '@mui/icons-material/GppMaybe';
import Title from './Title';
import { ProcessusLog } from '../../../models/processusLog';

export default function Alert(props: { logs: ProcessusLog[] | null }) {
	const [allLogs] = useState<ProcessusLog[] | null>(props.logs);
	const [logError, setLogError] = useState<ProcessusLog | null>(null);
	const [dateError, setDateError] = useState<Date | null>(null);
	const color = logError ? 'error' : 'success';

	useEffect(() => {
		if (allLogs) {
			const logs: ProcessusLog[] = [...allLogs];
			for (let log of logs) {
				// Créer un object "Date" sinon on n'auras pas accès aux fonctions getMonth ect
				const dateLog: Date = new Date(log.date);
				const dateNow: Date = new Date();

				if (log.errorStack !== '' && dateLog.getDate() === dateNow.getDate() && dateLog.getMonth() === dateNow.getMonth()) {
					setLogError(log);
					setDateError(dateLog);
				}
			}
		}
	}, [allLogs]);

	return (
		<React.Fragment>
			<Title>Status du jour</Title>
			<GppMaybeIcon color={color} fontSize="large"></GppMaybeIcon>
			<Typography component="p" variant="h6">
				{logError ? logError.message : 'Aucune erreur trouvée'}
			</Typography>
			<Typography color="text.secondary" sx={{ flex: 1 }}>
				{dateError && `à ${dateError.getHours()}h ${dateError.getMinutes()}min`}
			</Typography>
		</React.Fragment>
	);
}
